import { createFileRoute, redirect } from '@tanstack/react-router'
import SignIn2 from '@/features/auth/sign-in/sign-in-2'
import { useAuthStore } from '@/stores/authStore'

export const Route = createFileRoute('/(auth)/sign-in')({
  beforeLoad: () => {
    const token = useAuthStore.getState().auth.accessToken
    if (token) throw redirect({ to: '/' })
  },
  component: SignInRouteComponent,
})

function SignInRouteComponent() {
  const search = Route.useSearch() as { token?: string }
  const hasResetToken = Boolean(search?.token)

  return <SignIn2 initialRegisteredMode={hasResetToken} />
}
